import React from 'react';
import cn from 'classnames';
import './styles.scss';

interface ICmFilter {
  title: string;
  id: number;
  checked?: boolean;
  onToggle: (id: number, checked: boolean) => void;
}

export const CmFilter = ({
  title,
  id,
  checked = false,
  onToggle
}: ICmFilter): JSX.Element => {
  const handleToggle = () => {
    onToggle(id, !checked);
  };

  return <div
    className={cn('cm-filter', {'cm-filter--checked': checked})}
    role="presentation"
    onClick={handleToggle}><div className="cm-filter__text">{title}</div>
  </div>;
};
